import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ClientService } from '../../../core/services/client/client.service';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ConfigService } from 'src/app/core/services/config.service';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-search-school',
    templateUrl: './search-school.component.html',
    styleUrls: ['./search-school.component.scss'],
    standalone: false
})
export class SearchSchoolComponent implements OnInit, OnDestroy {

  clients = [];
  clientListSubscription: Subscription;
  filteredClients: Observable<any[]>;

  selectedClient: any;
  selectedClientSubscription: Subscription;

  searchSchoolForm = new UntypedFormGroup({
    client: new UntypedFormControl('')
  });
  showSchoolSearch = true;
  handleSchoolslectionSubscription: Subscription;
  currentRoutePath: string;
  previousRute: string;
  currentUrl: string;
  constructor(
    private clientService: ClientService,
    private configService: ConfigService,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        this.currentRoutePath = `/${event.snapshot.routeConfig.path}`;
      }
    });
    this.currentUrl = this.router.url;
  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.currentUrl = event.urlAfterRedirects;
    }
  });
    this.clientListSubscription = this.clientService.clientList.subscribe(clients => {
      if(clients){
        if(JSON.stringify(this.clients) !== JSON.stringify(clients)){
          this.clients = clients;
          this.searchSchoolForm.controls['client'].setValue('');
          this.checkAndSetClient();
        }
      }
    });

    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      this.selectedClient = client;
      this.checkAndSetClient();
    });
    this.handleSchoolslectionSubscription = this.clientService.handleSchoolSelect.subscribe(con=>{
      this.showSchoolSearch = con;
  });
  }
  ngOnDestroy(): void {
    this.clientListSubscription.unsubscribe();
    this.selectedClientSubscription.unsubscribe();
    this.clientListSubscription.unsubscribe();
    this.handleSchoolslectionSubscription.unsubscribe();
  }

  getSearchLabel() {
    return (!this.selectedClient ? 'Search ' : '') + 'Client Name or Client Number';
  }

  checkAndSetClient() {
    // Set Selected Client if checked
    if (this.selectedClient && this.selectedClient.checked) {
      this.setClient(this.selectedClient);
    }

    if (this.clients.length > 0 && this.selectedClient) {
      if (!this.selectedClient.checked) {
        const checkClient = this.clients.find(_client => _client.Id === Number(this.selectedClient.Id));
        if (checkClient) {
          checkClient.checked = true;
          checkClient.PolicyYear = this.selectedClient.PolicyYear;
          this.setClient(checkClient);
          this.clientService.setSelectedClient(checkClient);
        } else {
          this.clientService.setSelectedClient(null);
        }
      }
    }
  }

  setClient(client) {
    if(this.clients.find(x=>x.Id==client.Id)){
    this.searchSchoolForm.controls['client'].setValue(client);
    }
    if (this.clients.length === 1) {
      this.searchSchoolForm.disable();
    }else{
      this.searchSchoolForm.enable();
    }
  }


  ngOnInit() {
    this.filteredClients = this.searchSchoolForm.controls.client.valueChanges
      .pipe(
        startWith<string | any>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => this._filter(name))
      );
  }

  private _filter(name: string) {
    let emptyClient = [{
      Name: 'No Client(s) Found',
      Id: 0,
      Number: 0,
      EnrollmentEnabled: true
    }];
    if(!name)
    {
      return this.clients.length > 0 ? this.clients : emptyClient;
    }
    const filterValue = name.toLowerCase();

    let filteredClients = this.clients.filter(option => {
      return option.Name.toLowerCase().replace(' - ', ' ').indexOf(filterValue) > -1
        || option.Name.toLowerCase().indexOf(filterValue) > -1
        || option.Number.toString().indexOf(filterValue) > -1
        || this.displayFn(option).toLowerCase().indexOf(filterValue) > -1;
    });

    filteredClients = filteredClients.length === 0 ? emptyClient : filteredClients;
    return filteredClients;
  }

  setDefaultClient() {
    if (this.clients.length === 1) {
      setTimeout(() => {
        this.searchSchoolForm.controls['client'].setValue(this.clients[0]);
      }, 200);
    } else {
      this.searchSchoolForm.controls['client'].setValue('');
    }
  }

  updateForm(newObj) {
    if (newObj.isUserInput) {
      if ((newObj.source.value.Id > 0) && (newObj.source.value.Number > 0)) {
        this.searchSchoolForm.controls['client'].setValue(newObj.source.value);
        this.clientService.setSelectedClient(newObj.source.value);
        // Navigates to thhe module home page Changes for Jira PC-1374 on 27-July-22
        this.router.navigateByUrl(this.currentRoutePath);
        return;
      } else {
        this.searchSchoolForm.controls['client'].setValue(this.selectedClient);
      }
    }
  }

  clientControlChange() {
    if (this.searchSchoolForm.controls['client'].value === '' && this.selectedClient) {
      this.searchSchoolForm.controls['client'].setValue(this.selectedClient);
      this.searchSchoolForm.controls['client'].setValue(this.selectedClient);
    }
  }

  closed() {
    setTimeout(() => {
      if (
        this.searchSchoolForm.controls['client'].value === '' ||
        this.searchSchoolForm.controls['client'].value === null ||
        typeof this.searchSchoolForm.controls['client'].value === 'string' ||
        this.searchSchoolForm.controls['client'].value.Number == null
      ) {
        if (!this.selectedClient) {
          this.searchSchoolForm.controls['client'].setValue('');
        } else {
          this.searchSchoolForm.controls['client'].setValue(this.selectedClient);
        }
      }
    }, 300);
  }

  displayFn(client) {
    if (typeof client === 'string') { return undefined; }
    return (client && client.Number ? client.Name + ' (' + client.Number + ')' : undefined);
  }

  tooltip(client) {
    if (client) {
      return client.Name + (client.Number ? ' : ' + client.Number : '');
    } else {
      if (this.selectedClient) {
        return this.selectedClient.Name + (this.selectedClient.Number ? ' : ' + this.selectedClient.Number : '');
      }
    }
  }
}
